import { Paper } from "@mui/material"

import { makeStyles } from "makeStyles"

const useStyles = makeStyles()((theme) => ({
	content: {
		maxWidth: "700px",
		margin: "3rem auto 0 auto",
	},
	paper: {
		padding: theme.spacing(4),
		color: theme.palette.secondary.dark,
		boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.15)",
	},
}))

const SeoContent = ({ category, language }: Props) => {
	const { classes } = useStyles()

	const longSeoText =
		category?.custom?.customFieldsRaw?.find(({ name }) => name === "longSeoText")?.value?.[
			language
		] ?? category?.longSeoText?.[language]

	if (!longSeoText) return null

	return (
		<div className={classes.content} id="seoLongText">
			<Paper className={classes.paper}>
				<div dangerouslySetInnerHTML={{ __html: longSeoText }}></div>
			</Paper>
		</div>
	)
}

interface Props {
	category: any
	language: string
}

export default SeoContent
